module.exports = __webpack_public_path__ + "static/media/satisfication_guar_image.25bc6967.svg";